<template>
  <div class="page-with-top-bar">
    <layout-builder ref="refLayoutBuilder"
          :entity-id="projectId"
          :type-pictogram="typePictogram"
          :can-actions-pictogram="canActionsPictogram"
          @epc-reload="() => { $emit('epc-reload') }"
        />
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import LayoutBuilder from '../../components/pictograms/layout-builder/LayoutBuilder.vue';

  export default {
    middleware: "auth",
    title: "process_pictogram_page_title",

    components: {
      LayoutBuilder
    },

    computed: {
      ...mapGetters({
        navData: "app/navData",
        user: "auth/user",
      }),

      projectId() {
        return parseInt(this.navData.project_id);
      },

      // Convierte el route param (con guiones) al valor que usa el backend
      // y la constante PICTOGRAM_TYPES (con underscores). Ej:
      // 'mechanical-installation' → 'mechanical_installation'
      typePictogram() {
        return (this.type || 'mechanical-installation').replace(/-/g, '_')
      }
    },

    data: () => ({
      canActionsPictogram: {
        'mode_dashboard': false,
        'show_header': true,
        'save': true,
        'select_entity': false
      },
      type: null,
    }),

    watch: {

    },

    created() {
      let projectName = this.navData.project_name
        ? this.navData.project_name.toUpperCase()
        : "";

      this.type = this.$route.params.type ?? 'mechanical-installation';

      // Title dinámico: traduce la etiqueta del tipo (ej. "instalación mecánica")
      // y la inyecta como {0} de `process_pictogram_page_title`.
      // El mixin global en frontSub/layouts/appfix.vue lee $options.title en mounted()
      // y resuelve arrays como [key, ...args] vía $t(key, args).
      const typeKey = 'type_' + this.type.replace(/-/g, '_')
      this.$options.title = ['process_pictogram_page_title', this.$t(typeKey)]

      this.$options.subtitle = ["project_actions_page_subtitle", [projectName]];

      this.entityId = this.projectId;
    },

    mounted() {

    },

    beforeDestroy(){
    },

    methods: {


      _HandlePictogramsRefresh() {
        this.$refs.refManagePictograms.RefreshListPictograms()
        this.mainActiveTab = 0
      }
    }
  };
</script>
